<template>
  <div class="asc-session-expiry-dialog">
    <asc-dialog
      :show-dialog="showDialog"
      :text="dialogTitle"
      :on-primary="handleSaveExitSession"
      :on-secondary="handleExitWithoutSavingSession"
      :on-close="handleContinueSession"
      :secondary-button-text="secondaryButtonText"
      :primary-button-text="primaryButtonText"
    >
      {{ dialogText }}
    </asc-dialog>
  </div>
</template>

<script>
import { AscDialogMixin } from '@/components/mixins'
import AscDialog from '@/components/atoms/AscDialog'

export default {
  name: 'AscMxRecDialog',

  components: {
    AscDialog,
  },

  mixins: [AscDialogMixin],

  props: {
    isConfirmation: {
      type: Boolean,
      default: false,
    },
    onSaveExitSession: {
      type: Function,
      required: true,
    },
    onExitWithoutSavingSession: {
      type: Function,
      required: true,
    },
    onContinueSession: {
      type: Function,
      required: true,
    },
    hasData: {
      type: Boolean,
      default: false,
    },
    statusIdUpdated: {
      type: Boolean,
      default: false,
    },
    attachmentAdded: {
      type: Boolean,
      default: false,
    },
    changesMade: {
      type: Boolean,
      default: false,
    },
    followUpDataChanges: {
      type: Boolean,
      default: false,
    },
    isPlotlyDirty: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    dialogText() {
      return this.isConfirmation &&
        this.hasData &&
        (this.changesMade ||
          this.followUpDataChanges ||
          this.statusIdUpdated ||
          this.attachmentAdded ||
          this.isPlotlyDirty)
        ? 'You are about to exit this page without saving your changes.'
        : this.isConfirmation &&
          (this.changesMade ||
            this.followUpDataChanges ||
            this.statusIdUpdated ||
            this.attachmentAdded ||
            this.isPlotlyDirty)
        ? 'You are about to exit this page without saving your changes.'
        : (this.isConfirmation && this.hasData) || this.isPlotlyDirty
        ? 'You are about to exit this page without saving your changes.'
        : 'Your session will expire in 10 minutes. Please choose to continue editing or save and exit.'
    },
    dialogTitle() {
      return this.isConfirmation ? 'Confirm' : 'Your Session Is Expiring Soon'
    },
    secondaryButtonText() {
      return this.isConfirmation ? 'Exit without Saving' : 'Continue Editing'
    },
    primaryButtonText() {
      return this.isConfirmation &&
        this.hasData &&
        (this.changesMade ||
          this.followUpDataChanges ||
          this.statusIdUpdated ||
          this.attachmentAdded ||
          this.isPlotlyDirty)
        ? 'Save And Exit'
        : this.isConfirmation &&
          (this.changesMade ||
            this.followUpDataChanges ||
            this.statusIdUpdated ||
            this.attachmentAdded ||
            this.isPlotlyDirty)
        ? 'Save And Exit'
        : this.isConfirmation && this.hasData
        ? 'Save And Exit'
        : 'Save And Exit'
    },
  },

  methods: {
    handleSaveExitSession() {
      //if post and exit, if save and exit, if post, save & exit
      this.onSaveExitSession()
      this.handleClose()
    },
    handleContinueSession() {
      this.onContinueSession()
      this.handleClose()
    },
    handleExitWithoutSavingSession() {
      this.onExitWithoutSavingSession()
    },
  },
}
</script>
<style lang="scss">
.asc-session-expiry-dialog {
  .asc-dialog {
    .v-card__text {
      min-height: 120px !important;
      padding: 16px 16px 19px !important;
    }
  }
}
</style>
